<div class="modal container-fluid" [class.modal-hidden]="!showModal" (click)="hideModal()">
  <div class="row">
    <div class="modal-content mx-auto p-3"
      [class.alert]="['success', 'error'].indexOf(modalType) != -1"
      [class.alert-success]="modalType == 'success'"
      [class.alert-danger]="modalType == 'error'"
      [class.alert-warning]="modalType == 'warning'">
      @if (header) {
        <div class="row justify-content-start modal-header m-0">
          <div class="col-12">{{header}}</div>
        </div>
      }
      <div class="modal-text"><div innerHTML="{{content}}"></div></div>
      @if (buttons?.length > 0) {
        <div class="modal-footer">
          @for (button of buttons; track button) {
            <div>
              <p-button type="button" [label]="button.text" [severity]="modalButtonSeverity(button)"
                [outlined]="modalButtonOutlined(button)" styleClass="modal-button"
                [ngClass]="modalButtonExtraHostClasses(button)" (onClick)="buttonClick(button.result)" />
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

<div class="modal-background" [class.modal-hidden]="!showModal"></div>
